// Pure-constants module for the resort header nav enums. See
// @/components/common/HeaderNav/types for the rationale (server-side
// modules need to import enum members without tripping the React Client
// Manifest). The existing constants.tsx imports React + SVGs at module
// top level, which makes its enum exports unusable from server.ts files.

export enum CurrentTab {
  SNOW = 'snow_reports',
  TRIP_PLANNING = 'trip_planning',
  // FLIGHTS = 'flights',
  // CAR_RENTALS = 'car-rentals',
  BOOK_TRIP = 'book-trip',
}

export enum CurrentLink {
  SNOW_REPORT = 'snow_reports',
  WEATHER = 'weather',
  CAMS = 'cams',
  FHR = 'first_hand',
  OVERVIEW = 'ski-resort',
  REVIEWS = 'reviews',
  TRAILMAP = 'trailmap',
  SNOWPLANNER = 'snowplanner',
  LIFTACCESS = 'liftaccess',
  LIFT_TICKETS = 'lift-tickets',
  SKI_RENTALS = 'skirentals',
  BOOK_TRIP = 'book-trip',
  SUMMER_OVERVIEW = 'summer-overview',
}
